export default {
  actions: {
    getCoupon(context, payload) {
      return this.$container.dao.getCoupon(payload);
    },
    updatePayment(context, payload) {
      return this.$container.dao.updatePayment(payload);
    },
    getPayment(context, memberId) {
      return this.$container.dao.getPayment(memberId);
    },
    cancelSubscription(context, memberId) {
      return this.$container.dao.cancelSubscription(memberId);
    },
  },
};
